export interface IReCaptchaRequest {
  reCaptchaToken: string;
  alternateReCaptchaToken?: string;
}

export enum ReCaptchaAction {
  createUser = 'CreateUser',
  createPasswordLoginToken = 'CreatePasswordLoginToken',
  createTwoFactorLoginToken = 'CreateTwoFactorLoginToken',
  sendPasswordResetToken = 'SendPasswordResetToken',
  sendPasswordResetTokenByCardNumber = 'SendPasswordResetTokenByCardNumber',
  resetPasswordTokenValidation = 'ResetPasswordTokenValidation',
  resetPassword = 'ResetPassword',
  resetEmailCodeValidation = 'ResetEmailCodeValidation',
  resetEmailAddress = 'ResetEmailAddress',
  checkCardStatus = 'CheckCardStatus',
  checkUserExistence = 'CheckUserExistence',
  sendPublicContactForm = 'SendPublicContactForm',
  getContentSuggestions = 'GetContentSuggestions',
  activateRegistrationCampaign = 'ActivateRegistrationCampaign',
  createCampaignUser = 'CreateCampaignUser',
  createLightCampaignUser = 'CreateLightCampaignUser',
  getAddressSuggestion = 'GetAddressSuggestion',
  sendEmailAddressVerificationCode = 'SendEmailAddressVerificationCode',
  sendEmailResetCode = 'SendEmailResetCode',
  sendPasswordVerificationCode = 'SendPasswordResetCode',
  emailAddressVerificationCodeValidation = 'EmailAddressVerificationCodeValidation',
  prepareFileUpload = 'PrepareFileUpload'
}
